module.exports = __webpack_public_path__ + "static/media/howwork-hover1-2.32acdfb8.svg";